"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ref = exports.isMagicRef = void 0;
function isMagicRef(value) {
    return value && typeof value.$ref === 'function';
}
exports.isMagicRef = isMagicRef;
function ref(model) {
    return {
        $ref: model,
    };
}
exports.ref = ref;
